import { render } from "./SelectStatusDeliveries.vue?vue&type=template&id=5f32f46a&scoped=true"
import script from "./SelectStatusDeliveries.vue?vue&type=script&lang=js"
export * from "./SelectStatusDeliveries.vue?vue&type=script&lang=js"

import "./SelectStatusDeliveries.vue?vue&type=style&index=0&id=5f32f46a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f32f46a"]])

export default __exports__